import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router';

import { Button, Checkbox, Col, Modal, Row, Skeleton, Typography } from 'antd'
import { ConsoleSqlOutlined, DeleteOutlined, UsergroupAddOutlined } from '@ant-design/icons';

import { LOCAL_MERCHANT_CODE, LOCAL_NOT_SHOW_NEW_OPERATION_ALERT } from '../../../helpers/Globals';
import MarketingAudienceCard from '../../marketing/audience/MarketingAudienceCard';
import createOperation from '../../marketing/operations/MarketingOperationCreate';
import createAudience from '../../marketing/audience/MarketingAudienceCreate';
import { apiDeleteAudience, apiGetAllAudiences } from '../../../helpers/Api';
import showAudience from '../../marketing/audience/MarketingAudienceShow';
import MarketingEmpty from '../../marketing/MarketingEmpty';
import DashboardLayout from '../../DashboardLayout';
import DiSkeletonCards from '../../DiSkeletonCards';
import { Context } from '../../../helpers/Context';
import confirmModal from '../../DiConfirmModal';

export default function PageAudiences() {
  
  const [selectedAudienceTitles, setSelectedAudienceTitles] = useState([]);
  const [showDeleteAudience, setShowDeleteAudience] = useState(false);
  const [selectedAudience, setSelectedAudience] = useState([]);
  const [savedAudienceId, setSavedAudienceId] = useState(null);
  const [refreshAudiences, setRefreshAudiences] = useState(0);
  const [audiences, setAudiences] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openNewOperationModal, setOpenNewOperationModal] = useState(false);
  
  const contextValue = useContext(Context);
  const navigate = useNavigate();
  
  const {
    successNotification,
    errorNotification,
    publicCode,
    diAppRef,
  } = contextValue;
  
  /////////////////////////////////////////////////////////////////////////////////////////// 
  //////////////////// funzione per creare l'array di pubblici selezionati ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////
  
  const clearSelectedAudiences = () => {
    setSelectedAudience([]);
    setSelectedAudienceTitles([]);
  }
  
  const onClickAudience = ({ audienceId, title }) => {
    setSelectedAudienceTitles((prevTitles) =>
     prevTitles.includes(title) ? prevTitles.filter((item) => item !== title) : [...prevTitles, title]
    );
    setSelectedAudience((prevIds) =>
     prevIds.includes(audienceId) ? prevIds.filter((item) => item !== audienceId) : [...prevIds, audienceId]
    );
  }
  /////////////////////////////////////////////////////////////////////////////////////////// 
  //////////////////// funzione per creare l'array di pubblici selezionati ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////

  /////////////////////////////////////////////////////////////////////////////////////////// 
        // funzione per aggiornare il pubblico passata a tutti i componenti figli //
  ///////////////////////////////////////////////////////////////////////////////////////////
    const onSave = (savedAudienceId) => {
      setSavedAudienceId(savedAudienceId);
      setRefreshAudiences(refreshAudiences + 1)
    }
    
    useEffect(() => {
       if (!savedAudienceId) return;
        //logica per aprire la modal che rimanda a creare un'operazione dopo il salvataggio audience
        const openModal = localStorage.getItem(LOCAL_NOT_SHOW_NEW_OPERATION_ALERT);
        if (!openModal) {
          setTimeout(() => {
            setOpenNewOperationModal(true);
          }, 1000);
        }
      
    },[savedAudienceId])
  /////////////////////////////////////////////////////////////////////////////////////////// 
        // funzione per aggiornare il pubblico passata a tutti i componenti figli //
  ///////////////////////////////////////////////////////////////////////////////////////////

  /////////////////////////////////////////////////////////////////////////////////////////// 
              //////////////////// recupero i dati del pubblico ///////////////
  /////////////////////////////////////////////////////////////////////////////////////////// 
  
  useEffect(() => {
    
    if (!publicCode || publicCode === "") return;
    setLoading(true);

    try {
     (async () => {
       const res = await apiGetAllAudiences(publicCode);
       
       if (!res?.message) {
         setAudiences(res.data)
         setLoading(false)
         setShowDeleteAudience(false)
       } else {
          setLoading(false)
          errorNotification(res.message)
       }
     })();
    } catch (error) {
      errorNotification(JSON.stringify(error))
      console.log(error)
    }

  },[refreshAudiences])
  
  /////////////////////////////////////////////////////////////////////////////////////////// 
              //////////////////// recupero i dati del pubblico ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////
  
  ///////////////////////////////////////////////////////////////////////////////////////////
    //////////////////// controlli sul pubblico selezionato ed eliminazioni ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////
  const deleteAudiences = async () => {
        
    const body = {
      "ids": selectedAudience
    };

    try {
       const result = await confirmModal(
         "Stai per eliminare il pubblico selezionato, sicuro di voler continuare?",
         contextValue
      ); //attendo la risposta dal componente di conferma modale
      if (result) {
        setLoading(true);
    
        const res = await apiDeleteAudience(publicCode, body);
        if (!res.message) {
          clearSelectedAudiences();
          successNotification("Pubblico eliminato con successo")
          setRefreshAudiences(refreshAudiences + 1)
          setLoading(false);
        } else {
          console.log(res)
          setLoading(false);
          errorNotification(res.message)
        }
      }
    } catch (error) {
      setLoading(false)
      errorNotification(error?.message)
      console.log(error)
    }
   
  }
  
  useEffect(() => {
    setShowDeleteAudience((selectedAudience.length === 0 || !selectedAudience )? false : true);
  },[selectedAudience])
  
  /////////////////////////////////////////////////////////////////////////////////////////// 
    //////////////////// controlli sul pubblico selezionato ed eliminazioni ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////

  const redirectToOperations = () => {
    navigate("/marketing/marketing-operations")
  };

  return (
    <DashboardLayout hideShops={true}>
      
      {/* --------- sezione del pubblico ---------  */}
      <Row className='p-20'>
        <div className='di-card mb-20 w-100'>
          {loading ?
              <>
                <Skeleton.Input className='w-100 p-10 mb-10 radius-2' active />
                <DiSkeletonCards />
              </>
            :
              <>
                {!audiences || audiences.length === 0 ? //condizione per mostrare o meno il pubblico
                    
                  //------------ aggiungi un pubblico quando non ne hai nessuno -----------
                    <MarketingEmpty contextValue={contextValue} onSave={onSave} />
                  //------------ aggiungi un pubblico quando non ne hai nessuno -----------
                :
                  // ------- ciclo per mostrare il pubblico ----------
                    <>
                      <div className='flex flex-wrap align-center justify-end mb-20 gap-20'>
             
                        <div className='flex flex-wrap gap-10 align-center justify-end'>
                            <Button
                              onClick={() => {
                                showAudience({
                                  context:contextValue,
                                  audienceIdArray:selectedAudience,
                                  audienceTitlesArray:selectedAudienceTitles
                                })
                              }}
                              className='flex-grow'
                              ref={diAppRef.refAudienceShow}
                            >
                              Mostra Pubblico
                            </Button>
                            <Button
                              className='flex-grow'
                              onClick={() => {
                                createAudience({ context: contextValue, onSave: onSave })
                                setTimeout(() => {
                                  clearSelectedAudiences();
                                }, 500);
                              }
                            }
                            ref={diAppRef.refAudienceCreate}
                            type='primary'
                          >
                                + Crea Pubblico
                          </Button>
                      
                          {showDeleteAudience &&
                            <Button 
                              className='flex-grow animate scaleIn '
                              danger
                              icon={<DeleteOutlined/>}
                              onClick={deleteAudiences}
                            />
                          }
                        </div>
                      </div>
                      
                      <Row gutter={[20, 20]}>
                        {audiences.length > 0 && audiences.map((e) => {
                            return (
                              <Col key={e.id} span={8} xs={24} sm={12}  md={12} lg={8}>
                                <MarketingAudienceCard
                                  selectedAudience={selectedAudience}
                                  contextValue={contextValue}
                                  description={e.description}
                                  onChange={onClickAudience}
                                  amount={e.potentialUsers}
                                  onSave={onSave}
                                  title={e.title}
                                  id={e.id}
                                />
                              </Col>
                            )
                          })
                        }
                      </Row>
                  </>
                  // ------- ciclo per mostrare il pubblico ----------
                }
              </>
          }
        </div>
      </Row>
      {/* --------- sezione del pubblico ---------  */}

      {/* --------- modal per andare direttamente ad un'operazione ---------  */}
      <Modal
        open={openNewOperationModal} ù
        onClose={()=>setOpenNewOperationModal(false)}
        onCancel={()=>setOpenNewOperationModal(false)}
        title="Creare un'operazione?"
        cancelText="No grazie"
        okText="Si"
        onOk={() => {
          setOpenNewOperationModal(false);
          setTimeout(() => {
            createOperation({ context: contextValue, preSelectedAudience:savedAudienceId, onSave:redirectToOperations })
          }, 500);
        }}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className='flex flex-wrap gap-10 space-between align-center mt-10'>
            <div className='flex gap-10 align-center'>
              <Checkbox
                defaultChecked={localStorage?.getItem(LOCAL_NOT_SHOW_NEW_OPERATION_ALERT)}
                onChange={(e) => localStorage?.setItem(LOCAL_NOT_SHOW_NEW_OPERATION_ALERT, e.target.checked)}
              />
              <Typography className='fs-12'>Non mostrare più questo messaggio</Typography>
            </div>
            <div className='flex gap-10'>
              <CancelBtn />
              <OkBtn />
            </div>
          </div>
        )}
        
      >
        <div className='flex column gap-10'>
          <Typography>Sembra che tu abbia creato o modificato il tuo pubblico. Vuoi creare subito un'operazione di marketing?</Typography>
        </div>
      </Modal>
      {/* --------- modal per andare direttamente ad un'operazione ---------  */}

  </DashboardLayout>
  )
}
